import { useEffect, useState } from 'react';
import { ICONE_TEMA, NOME_TEMA, Tema, aplicarTema, lerTema, proximoTema }
  from './tema';

/**
 * O alternador de tema.
 *
 * Um botão só, que roda entre os três estados, e não três botões: o
 * portal tem uma tarefa e o cabeçalho não pode virar painel de
 * controle. O `title` e o rótulo invisível dizem em que estado ele
 * está — um ícone de lua sozinho não conta se o escuro está ligado ou
 * se é só o botão de ligá-lo.
 *
 * Morava em `main.tsx` e só aparecia depois de entrar. Na onda 284 ele
 * passou a aparecer também na entrada (achado P3 #17 da revisão de
 * 03/10): quem abre o portal à noite escolhe o tema antes de digitar o
 * e-mail, e não depois.
 */
export function BotaoDeTema() {
  const [tema, setTema] = useState<Tema>(lerTema);
  useEffect(() => { aplicarTema(tema); }, [tema]);
  return (
    <button
      type="button"
      className="botao-faixa botao-tema"
      title={`${NOME_TEMA[tema]} — tocar para mudar`}
      onClick={() => setTema(proximoTema(tema))}
    >
      <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true"
           fill="none" stroke="currentColor" strokeWidth="2"
           strokeLinecap="round" strokeLinejoin="round">
        <path d={ICONE_TEMA[tema]} />
      </svg>
      <span className="so-leitor">{NOME_TEMA[tema]}</span>
    </button>
  );
}
